<script setup lang="ts">
/**
 * SyncQueueBootstrap (P.4)
 *
 * Mount-only component — purpose is to call `useSyncQueue()` so the
 * online/offline listeners are installed at app startup, BEFORE the
 * user navigates to any route.
 *
 * Renders nothing. Will be removed when Vue Router calls
 * `<KeepAlive>` and the indicator can take over (Phase 2 cleanup).
 *
 * Behavior:
 *  - Calls useSyncQueue() which idempotently:
 *    1. Refreshes pending count from IndexedDB
 *    2. Registers `window.online` + `window.offline` listeners (once per page)
 *    3. If navigator.onLine on mount → triggers processQueue() to clear stale queue
 */

import { useSyncQueue } from "../composables/useSyncQueue";
useSyncQueue();
</script>

<template>
  <!-- intentionally empty — listener installation only -->
</template>
